function _defineProperty(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}

function _objectSpread(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = null != arguments[t] ? arguments[t] : {},
        r = Object.keys(n);
    "function" == typeof Object.getOwnPropertySymbols && (r = r.concat(Object.getOwnPropertySymbols(n).filter(function (e) {
      return Object.getOwnPropertyDescriptor(n, e).enumerable;
    }))), r.forEach(function (t) {
      _defineProperty(e, t, n[t]);
    });
  }

  return e;
}

var freeze = function freeze(e, t, n) {
  Object.defineProperty(e, t, {
    configurable: !0,
    get: function get() {
      return n;
    },
    set: function set(e) {
      console.warn("tried to set frozen property ".concat(t, " with ").concat(e));
    }
  });
},
    component = {
  abstract: !0,
  name: "Fragment",
  props: {
    name: {
      type: String,
      default: function _default() {
        return Math.floor(Date.now() * Math.random()).toString(16);
      }
    },
    html: {
      type: String,
      default: null
    }
  },
  mounted: function mounted() {
    var e = this.$el,
        t = e.parentNode;
    e.__isFragment = !0, e.__isMounted = !1;
    var n = document.createComment("fragment#".concat(this.name, "#head")),
        r = document.createComment("fragment#".concat(this.name, "#tail"));
    e.__head = n, e.__tail = r;
    var o = document.createDocumentFragment();

    if (o.appendChild(n), Array.from(e.childNodes).forEach(function (t) {
      var n = !t.hasOwnProperty("__isFragmentChild__");
      o.appendChild(t), n && (freeze(t, "parentNode", e), freeze(t, "__isFragmentChild__", !0));
    }), o.appendChild(r), this.html) {
      var a = document.createElement("template");
      a.innerHTML = this.html, Array.from(a.content.childNodes).forEach(function (e) {
        o.appendChild(e);
      });
    }

    var i = e.nextSibling;
    t.insertBefore(o, e, !0), t.removeChild(e), freeze(e, "parentNode", t), freeze(e, "nextSibling", i), i && freeze(i, "previousSibling", e), e.__isMounted = !0;
  },
  render: function render(e) {
    var t = this,
        n = this.$slots.default;
    return n && n.length && n.forEach(function (e) {
      return e.data = _objectSpread({}, e.data, {
        attrs: _objectSpread({
          fragment: t.name
        }, (e.data || {}).attrs)
      });
    }), e("div", {
      attrs: {
        fragment: this.name
      }
    }, n);
  }
};

function ssr(e, t) {
  "production" !== process.env.NODE_ENV && console.warn("v-fragment SSR is not implemented yet.");
}

var Fragment = component,
    SSR = ssr,
    Plugin = {
  install: function install(e) {
    e.component("fragment", component);
  }
},
    index = {
  Fragment: component,
  Plugin: Plugin,
  SSR: ssr
};
export default index;
export { Fragment, SSR, Plugin };